import { ResultPagDTO } from "@/interfaces/base-dto";
import { SituacaoClinicaDTO, SituacaoClinicaFiltroDTO, SituacaoClinicaParm } from "@/interfaces/clinic-situations";
import { ENDPOINTS } from "@/settings/api-settings";
import { from, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { apiClient } from "./api";

export function getClinicSituationsByFilter(
    filtros: SituacaoClinicaFiltroDTO,
): Observable<ResultPagDTO<SituacaoClinicaDTO>> {
    return from(apiClient.get(ENDPOINTS.CLINIC_SITUATIONS, filtros)).pipe(
        map((r: any) => {
            return !!r && r.data ? r.data : [];
        }),
    );
}

export function getClinicSituation(id: number): Observable<SituacaoClinicaDTO> {
    return from(apiClient.get(`${ENDPOINTS.CLINIC_SITUATIONS}/${id}`)).pipe(
        map((r: any) => {
            return !!r && r.data ? r.data : [];
        }),
    );
}

export function updateClinicSituation(parm: SituacaoClinicaParm, pdf: any): Observable<SituacaoClinicaDTO> {
    return from(apiClient.putMultipartFormData(`${ENDPOINTS.CLINIC_SITUATIONS}`, { parm, pdf })).pipe(
        map((r: any) => {
            return !!r && r.data ? r.data : [];
        }),
    );
}

export function saveClinicSituation(parm: SituacaoClinicaParm, pdf: any): Observable<SituacaoClinicaDTO> {
    if (parm.id) {
        return updateClinicSituation(parm, pdf);
    }
    return from(apiClient.postMultipartFormData(`${ENDPOINTS.CLINIC_SITUATIONS}`, { parm, pdf })).pipe(
        map((r: any) => {
            return !!r && r.data ? r.data : [];
        }),
    );
} 